import { formatProjectOrContractObject, simpleResponse } from "../api-helpers";
import { del, get, post, put } from "../../axios";
import { responseIsSuccessful } from "../../global-helpers";
import { Contract } from "../../models/Contract";
import { ApiResponseStatus } from "../../constants/enums";

export function generateQueryParams(contractId) {
  return contractId ? `?contract_id=${contractId}` : "";
}

export async function getContracts(projectId = undefined) {
  const queryParams = projectId ? `?project_id=${projectId}` : "";
  return await get(`contracts/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.contracts) {
        return res.data.contracts;
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function getContract(contractId) {
  return await get(`contracts/${contractId}`, window.localStorage.apiToken)
    .then(res => {
      let contractAndCounts = { contract: null, counts: {} };
      if (responseIsSuccessful(res)) {
        if (res.data.contract) {
          formatProjectOrContractObject(res.data.contract);
          contractAndCounts.contract = new Contract(res.data.contract);
        }
      }
      return contractAndCounts;
    })
    .catch(err => {
      console.log(err);
      return { contract: null, counts: {} };
    });
}

export async function storeContract(contract) {
  return post(
    "contracts",
    { contract_params: contract },
    window.localStorage.apiToken
  )
    .then(res => {
      let response = { status: ApiResponseStatus.ERROR, contract: null };
      if (responseIsSuccessful(res)) {
        response.status = ApiResponseStatus.SUCCESS;
        if (res.data.contract) {
          response.contract = res.data.contract;
        }
      }
      return response;
    })
    .catch(err => {
      console.log(err);
      return { status: ApiResponseStatus.ERROR, contract: null };
    });
}

export async function updateContract(contract) {
  return simpleResponse(
    put(
      `contracts/${contract.id}`,
      { contract_params: contract },
      window.localStorage.apiToken
    )
  );
}

export async function deleteContract(contract) {
  return simpleResponse(
    del(`contracts/${contract.id}`, window.localStorage.apiToken)
  );
}
